import { apiCall } from '@/lib/api-client';
import type {
  BugReport,
  BugReportFilters,
  BugReportPage,
  BugReportReporter,
  BugReportUpdateInput,
} from '@/types/api';

export const bugReportsApi = {
  /** Agent's own submitted bug reports (read-only). */
  mine: (limit = 50) => apiCall<BugReport[]>('/bug-reports/mine?limit=' + limit),

  list: (filters: BugReportFilters, limit = 25, offset = 0) => {
    const params = new URLSearchParams();
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    if (filters.status) params.set('status', filters.status);
    if (filters.severity) params.set('severity', filters.severity);
    if (filters.reporterId) params.set('reporterId', filters.reporterId);
    if (filters.from) params.set('from', filters.from);
    if (filters.to) params.set('to', filters.to);
    return apiCall<BugReportPage>(`/admin/bug-reports?${params.toString()}`);
  },

  reporters: () => apiCall<BugReportReporter[]>('/admin/bug-reports/reporters'),

  detail: (id: string) => apiCall<BugReport>(`/admin/bug-reports/${id}`),

  update: (id: string, body: BugReportUpdateInput) =>
    apiCall<BugReport>(`/admin/bug-reports/${id}`, {
      method: 'PATCH',
      body,
    }),
};
